<template lang="html">

    <div class="cover-popup row-center" v-if="mostrar">
      <div class="popup">

  
        <h2 class="title-pop">¡Atención!</h2>

        <p>Faltan datos obligatorios en tu perfil, por favor accede para completarlos en Mi perfil > Datos personales.​</p>
  
        <div class="contenedor-botones">
  
          <router-link to="/cv" class="btn -solid-primary">Ir a mi Perfil</router-link>
  
        </div>
  
      </div>
    </div>
  
  </template>
  
  <script lang="js">
    
      import {mapGetters,mapActions} from 'vuex';
    
      export default  {
        name: 'popup-faltan-datos-personales',
        mounted(){
            if(this.mostrar){
              this.request();
            }
        },
        computed : {
          ...mapGetters({
            brand:'getBrand',
            style : 'getStyles',
            mostrar : 'getfaltanDatosPersonalesObligatorios',
            
          })
        },
        methods : {
          ...mapActions(['checkDatosPersonalesObligatorios']),
          request(){
            this.checkDatosPersonalesObligatorios();
          }
        }
      }
    </script>
  <style scoped lang="scss">
  
    
    
    </style>


// WEBPACK FOOTER //
// src/components/parts/popup-rellenar-datos-personales.vue